<!-- Shop-page: brand-logo treatment only on 3/12 slides. Photo banners keep cover + max-width. -->
<div
  class="min-h-screen pb-page-bottom"
  [ngClass]="shopPageCarouselCompatClasses"
  [ngStyle]="getBackgroundStyles()"
  [style.backgroundColor]="backgroundColor | contentBuilderColor"
>
  <app-block-list [blockIdList]="body"></app-block-list>
  <router-outlet></router-outlet>
</div>
